import axios from "axios";

const USERS_URL =
  `${process.env.REACT_APP_API_URL}/users` ||
  "http://localhost:3001/api/users";

//2025-10-18
export async function getIsAdmin(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(USERS_URL + '/isadmin', { headers });
  return response.data;
}


//2025-09-28
export async function getAbreviatura(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(USERS_URL, { headers });
  return response.data;
}

export async function getSettings(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(USERS_URL, { headers });
  return response.data;
}

export async function updateSettings(newData, token) {
  const headers = { authorization: token };
  const response = await axios.patch(USERS_URL, newData, { headers });
  return response.data;
}
